<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { Button, Col, FormGroup, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Popover, Row } from "sveltestrap";
	import { containsService, directionsService, fileServices, paramsService, recordsUnidentifiedPerson, thirdsService, usersService, writeFileService } from "../services";
    import { dateInputFormatter, dateTimeInputFormatter } from "../services/Functions";
    import ParamSelect from "./ParamSelect.svelte";
    import ContainSelect from "./containSelect.svelte";
    import DirectionFormForModal from "./DirectionFormForModal.svelte";
    import DirectionForm from "./DirectionForm.svelte";
    import { REGISTERSUNIDENTIFIEDPERSON } from "../evironment";
    import type { User } from "../Model/User";

	const dispatch = createEventDispatcher();

	let size = 'lg';
	let open = false;
	let person;
	let buttonIn = true;
	let buttonOut = true;
	let deleteIn, deleteOut = false;
	let directionExists: boolean;
	let personExists = false;
	let direction;
	let files: any[] = [];
	let pop = false;
	const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));
	let currentUser: User;

	async function user() {
		currentUser = await usersService.findActualUser();
	}
	
	export let register = null;
	export let newRegister: boolean = false;

	$: open = !!register; 
	$: init(register)
	$: user();

	const toggle = () => {
	  size = 'lg';
	  open = !open;
	};

	async function init(register){
		if (!register) return;
		
		if (!register.new) {
			await loadPerson(register.id)
		}
		
		if (personExists) {
			await loadDirection(person.lugaridentificacion);
			
			register.lugaridentificacion = direction;
		}
	}

	async function save(){

		const response = await saveRegister();

		if(response){
			open = false;
			dispatch("registerUpdate", register);
		}
	}

	async function saveRegister(){
		return await recordsUnidentifiedPerson.saveRegisters(register);
	}

	async function loadPerson(id) {
		try {
			
			person = await recordsUnidentifiedPerson.findOne(id);

			personExists = true;

		} catch (err) {}
	}

  	async function loadDirection(directionId: string): Promise<void> {

		if(!directionId) return;

        const response = await directionsService.findOne(directionId)

		if(!response) {
			directionExists = false;
		} else {
			direction = directionId;
			directionExists = true;
		}

    }

	async function generateInput(type:string, visibility:boolean) {
		if (type == 'in') {
			let identificationInput = document.querySelector('#identification')
			let inDate = document.querySelector('#inDate');
			let inTime = document.querySelector('#inTime');
			
			if (visibility) {
				identificationInput.disabled = visibility;
				inDate.disabled = visibility;
				inTime.disabled = visibility;
				buttonIn = visibility;
				deleteIn = false;

				register.fecentrada = new Date();
				register.nidentifica = await recordsUnidentifiedPerson.lastIdentification(register.fecentrada.getFullYear());
				register.horainicio = new Date();
			} else {
				identificationInput.disabled = visibility;
				inDate.disabled = visibility;
				inTime.disabled = visibility;
				buttonIn = visibility;
			 	deleteIn = true;

				if (register.nidentifica) {
					register.nidentifica = register.nidentifica
				} else {
					register.nidentifica = await recordsUnidentifiedPerson.lastIdentification(new Date(register.fecentrada).getFullYear());
				}
				register.fecentrada = register.fecentrada;
				register.horainicio = register.horainicio;
			}
		} else if (type == 'out') {
			let outTime = document.querySelector('#outTime');
			
			if (visibility) {
				outTime.disabled = visibility;
				buttonOut = visibility;
				deleteOut = false;

				register.horafin = null;
			} else {
				outTime.disabled = visibility;
				buttonOut = visibility;
			 	deleteOut = true;

				register.horafin = new Date();
			}
		}

	}

	function updateInDate(data) {
		register.fecentrada = data.currentTarget.value
		generateInput('in', false);
	}

	async function download(fileId) {
		try {
			await writeFileService.writeUnidentifiedFile(register, fileId);
		} catch(error) {
			console.log(error);
		}
	}

	async function chooseFile() {
		try {
			files = await fileServices.findFilesByContext(REGISTERSUNIDENTIFIEDPERSON);
		} catch(error) {

		}
	}
	
</script>

	<Modal isOpen={open} {toggle} {size}>
		<ModalHeader {toggle}>Editar Registro</ModalHeader>
		<ModalBody>
			<Row>
				<Col xs="4">
					<FormGroup>
						<Label for="exampleEmail">Nº Identificación</Label>
						<Input
							id='identification'
							disabled
							type="text"
							bind:value={register.nidentifica}
						/>
					</FormGroup>
                </Col>
                <Col xs="4">
					<FormGroup>
						<Label for="exampleEmail">Fecha entrada</Label>
						<Input
							id='inDate'
							disabled
							type="date"
							value={dateInputFormatter(register.fecentrada)}  
							on:change={(event)=> updateInDate(event)}
						/>
					</FormGroup>
                </Col>
				<Col xs="3">
					<FormGroup>
						<Label for="mark">Hora Inicio</Label>
						<Input
							id='inTime'
							disabled
							type="time"
							value={register.horainicio}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs='1'>
						<FormGroup>
							{#if buttonIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('in',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('in',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
				<Col xs="3">
					<FormGroup>
						<Label for="mark">Hora Salida</Label>
						<Input
							id='outTime'
							disabled
							type="time"
							value={dateTimeInputFormatter(register.horafin)}
							on:change={(event) => person.horafin = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs="1">
						<FormGroup>
							{#if buttonOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('out',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('out',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
				<Col xs="6">
                    <FormGroup>
						<Label for="exampleEmail">Motivo</Label>
						<ContainSelect bind:containSelectId={register.motivoidentificacion} module='Registro General de Entrada y Salida' />
					</FormGroup>
                </Col>
                <Col xs="3">
                    <FormGroup>
						<Label for="exampleEmail">Agente</Label>
                        <ParamSelect
							bind:paramSelectId = {register.nagente}
							paramType = 'agentList'
							nothing = {true}
							on:change = {(event) => register.nagente = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				<Col xs="3">
					<Label for="exampleEmail">Diligencia</Label>
					<FormGroup>
						<Input
						    type="text"
                            bind:value={register.diligenciasidentificacion}  
						/>
					</FormGroup>
				</Col>
				<Col xs='12'>
					<Label for='exampleEmail'>Dirección</Label>
					<hr>
					{#if !directionExists}
						<DirectionFormForModal bind:directionId={register.lugaridentificacion} />	
					{:else}
						<DirectionForm bind:directionId={direction} thirdId='' />
					{/if}
				</Col>
				<Col xs="12">
                    <FormGroup>
						<Label for="exampleEmail">Observaciones</Label>
						<Input
                            type="textarea"
                            rows={6}
						    bind:value={register.observaciones}
						/>
					</FormGroup>
                </Col>
			</Row>

		</ModalBody>
		<ModalFooter>
			<Button color='success' id="btnDismissible" on:click={() => {chooseFile(); pop == false ? pop = true : pop = false}}>Descargar documento</Button>
			{#if pop}
				<div class='pop bg-white shadow-lg rounded-3 border border-1' >
					<div class='bg-light p-2 border- border-bottom'>
						Seleccione un fichero
					</div>
					<div class='p-4 d-flex flex-column'>
						{#if files.length > 0}
							{#each files as file}
								<button class='btn btn-secondary mb-2 fs-6' on:click={async() => {download(file.id); await delay(500).then(() => pop = false) }}>{file.name}</button>
							{/each}
						{:else}
							<span>No hay ficheros para descargar</span>
						{/if}
					</div>
				</div>
			{/if}
			<Button color="primary" on:click={save}>Guardar</Button>
	  	</ModalFooter>
	</Modal>

	<style>
		.pop {
			position: absolute;
			bottom: 60px;
			right: 100px;
			width: auto;
		}
	</style>